"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const x_date_pickers_1 = require("@mui/x-date-pickers/");
const AdapterLuxon_1 = require("@mui/x-date-pickers/AdapterLuxon");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const DatePicker = ({ date = null, onChange = () => { }, label = "Select a date", maxDate = undefined, disableFuture = false, }) => {
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(date);
    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
        onChange(newDate);
    };
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterLuxon_1.AdapterLuxon },
        react_1.default.createElement(material_1.Grid, { "data-testid": "date-picker_root", container: true, justifyContent: "space-around" },
            react_1.default.createElement(DatePicker_1.DatePicker, { label: label, value: selectedDate, onChange: handleDateChange, maxDate: maxDate, disableFuture: disableFuture, renderInput: (props) => react_1.default.createElement(material_1.TextField, { ...props }) }))));
};
exports.default = DatePicker;
